var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.value)}})]):_c('div',{staticClass:"rich-text"},[_c('div',{ref:"richDOM"})])
}
var staticRenderFns = []

export { render, staticRenderFns }